export interface ITranslation {
  [key: string]: ({}?: { [arg: string]: string|number }) => string;
}

export interface ILocales {
  [locale: string]: ITranslation;
}

const locales: ILocales = {
  'en': {
    searchByAccess: () => ('Access'),
    searchByArea: () => ('Snow Area'),
    searchByPrefecture: () => ('Prefecture'),
    accessStartingPoint: () => ('From'),
    accessTravel: () => ('Travel'),
    accessHours: () => ('Hours'),
    resortFound: ({ count }) => (`See ${count} Resort${count === 1 ? '' : 's'}`),
    areaName: () => ('Area'),
    prefectureName: () => ('Prefecture'),
    resortNotFound: () => ('Not Found'),
  },
  ja: {
    searchByAccess: () => ('所要時間で探す'),
    searchByArea: () => ('エリアから探す'),
    searchByPrefecture: () => ('都道府県から探す'),
    accessStartingPoint: () => ('出発地'),
    accessTravel: () => ('所要時間'),
    accessHours: () => ('時間'),
    resortFound: ({ count }) => (`${count} 件`),
    areaName: () => ('エリア'),
    prefectureName: () => ('都道府県'),
    resortNotFound: () => ('見つかりません'),
  },
  'zh-CN': {
    searchByAccess: () => ('根据所需时间搜索'),
    searchByArea: () => ('根据区域搜索'),
    searchByPrefecture: () => ('根据都道府县搜索'),
    accessStartingPoint: () => ('出发地'),
    accessTravel: () => ('所需时间'),
    accessHours: () => ('小时'),
    resortFound: ({ count }) => (`${count} 件`),
    areaName: () => ('区域'),
    prefectureName: () => ('都道府县'),
    resortNotFound: () => ('未找到滑雪场'),
  },
  'zh-HK': {
    searchByAccess: () => ('根據所需時間搜尋'),
    searchByArea: () => ('根據區域搜尋'),
    searchByPrefecture: () => ('根據都道府縣搜尋'),
    accessStartingPoint: () => ('出發地'),
    accessTravel: () => ('所需時間'),
    accessHours: () => ('小時'),
    resortFound: ({ count }) => (`${count} 件`),
    areaName: () => ('區域'),
    prefectureName: () => ('都道府縣'),
    resortNotFound: () => ('未找到滑雪場'),
  },
  'zh-TW': {
    searchByAccess: () => ('根據所需時間搜尋'),
    searchByArea: () => ('根據區域搜尋'),
    searchByPrefecture: () => ('根據都道府縣搜尋'),
    accessStartingPoint: () => ('出發地'),
    accessTravel: () => ('所需時間'),
    accessHours: () => ('小時'),
    resortFound: ({ count }) => (`${count} 件`),
    areaName: () => ('區域'),
    prefectureName: () => ('都道府縣'),
    resortNotFound: () => ('未找到滑雪場'),
  },
};

export default locales;
